module.exports = __webpack_public_path__ + "d62c733a24dc4a8f8724ba99844cd99f.jpg";